/* @minVersion 7.13.10 */
/* @onlyBabel7 */

import classPrivateFieldGet2 from "classPrivateFieldGet2";

export default function _classExtractFieldDescriptor(receiver, privateMap) {
  return classPrivateFieldGet2(privateMap, receiver);
}
